import { render, staticRenderFns } from "./Webcam.vue?vue&type=template&id=6811a079&scoped=true&"
import script from "./Webcam.vue?vue&type=script&lang=js&"
export * from "./Webcam.vue?vue&type=script&lang=js&"
import style0 from "./Webcam.vue?vue&type=style&index=0&id=6811a079&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811a079",
  null
  
)

export default component.exports